import * as React from "react";
const SvgIconPod = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={18}
    fill="#7878FA"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.874 9.49c.17-.303.17-.678 0-.98l-3.668-6a1 1 0 0 0-.872-.51h-6.66c-.361 0-.695.195-.872.51l-3.676 6c-.17.302-.17.677 0 .98l3.676 6c.177.314.51.51.872.51h6.66c.36 0 .695-.196.872-.51zm1.743-1.96a3.02 3.02 0 0 1 0 2.941l-3.668 6A3 3 0 0 1 13.334 18h-6.66a3 3 0 0 1-2.615-1.53l-3.676-6a3.02 3.02 0 0 1 0-2.942l3.676-6A3 3 0 0 1 6.674 0h6.66c1.082 0 2.084.586 2.615 1.53zm-6.18-3.476a.5.5 0 0 1 .183.683l-.5.866a.5.5 0 0 1-.683.183l-.866-.5a.5.5 0 0 1-.183-.683l.5-.866a.5.5 0 0 1 .683-.183zM8.12 3.737l.5.866a.5.5 0 0 1-.183.683l-.866.5a.5.5 0 0 1-.683-.183l-.5-.866a.5.5 0 0 1 .183-.683l.866-.5a.5.5 0 0 1 .683.183M5.504 7.999a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm2.932 4.715a.5.5 0 0 1 .183.683l-.5.866a.5.5 0 0 1-.683.183l-.866-.5a.5.5 0 0 1-.183-.683l.5-.866a.5.5 0 0 1 .683-.183zm4.683-.316.5.866a.5.5 0 0 1-.183.683l-.866.5a.5.5 0 0 1-.683-.183l-.5-.866a.5.5 0 0 1 .183-.684l.866-.5a.5.5 0 0 1 .683.184M15.503 8a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
    />
  </svg>
);
export default SvgIconPod;
